export const API_URL = "https://prserver.a3o.co";
export const IMG_PATH = "https://realestate.parecsa.com/listingImages";
